<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Barang Hilang</h5>
            </template>
            <DetailGadaiKomp :detailGadai="dataBarangHilang.detail.gadai" />
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">KETERANGAN</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan Pengajuan</b-col>
                    <b-col v-if="dataBarangHilang.detail.keteranganPengajuan != null">{{ dataBarangHilang.detail.keteranganPengajuan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Foto Pengajuan</b-col>
                    <b-col>
                        <a v-bind:href="$baseFilePath+dataBarangHilang.detail.foto" target="_blank">
                            <img width="150px" :src="$baseFilePath+dataBarangHilang.detail.foto" alt="Foto Pengajuan">
                        </a>
                        <span class="file-name mt-2"></span>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Eksekutor 1</b-col>
                    <b-col v-if="dataBarangHilang.detail.eks1 != null">{{ dataBarangHilang.detail.eks1 }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diproses Eksekutor 1 pada</b-col>
                    <b-col>{{ $helper.changeDateFormat(dataBarangHilang.detail.eks1ProcessedAt )}} {{ $helper.changeDateFormatGetHour(dataBarangHilang.detail.eks1ProcessedAt )}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan Eksekutor 1</b-col>
                    <b-col v-if="dataBarangHilang.detail.eks1Keterangan != null">{{ dataBarangHilang.detail.eks1Keterangan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Eksekutor 2</b-col>
                    <b-col v-if="dataBarangHilang.detail.eks2 != null">{{ dataBarangHilang.detail.eks2 }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diproses Eksekutor 2 pada</b-col>
                    <b-col>{{ $helper.changeDateFormat(dataBarangHilang.detail.eks2ProcessedAt )}} {{ $helper.changeDateFormatGetHour(dataBarangHilang.detail.eks2ProcessedAt )}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan Eksekutor 2</b-col>
                    <b-col v-if="dataBarangHilang.detail.eks2Keterangan != null">{{ dataBarangHilang.detail.eks2Keterangan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-edit-btn" >
                <b-button class="mr-2" variant="danger" name="batalBarangHilangBtn" v-if="dataBarangHilang.status == 'PENDING EKSEKUTOR 1'" @click="cancelBarangHilang">Batalkan</b-button>
            </div>
        </b-card>
        <b-modal id="modal-batalkan-hilang" title="Batalkan Nota Hilang" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="batalkanNotaHilangForm" @submit.prevent="onSubmitBatal">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Keterangan" class="mb-0">
                        <b-form-textarea
                        v-model="input.keteranganBatal"
                        name="keteranganBatal"
                        rows="3"
                        required
                        ></b-form-textarea>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelAjukanNotaBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeAjukanNotaBtn" :disabled="isSubmitting" type="submit" form="batalkanNotaHilangForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Batalkan'}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-barang-hilang',
    components: {
        DetailGadaiKomp
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            dataBarangHilang: {
                detail:{
                    gadai: {}
                }
            },
            input:{
                keteranganBatal: ""
            }
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleBarangHilang = this.$axios.get(`gadai-hilang/daftar-hilang-cabang/${this.id}`).then(response => {
                this.dataBarangHilang = response.data   
            })

            Promise.all([getSingleBarangHilang]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        cancelBarangHilang(){
            this.$bvModal.show("modal-batalkan-hilang")
        },

        onSubmitBatal(){
            let payload = {
                gadaiHilangId: this.id,
                keterangan: this.input.keteranganBatal
            }

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("gadai-hilang/batal/", payload).then(() => {
                this.$helper.setFlash("Pengajuan nota hilang berhasil dibatalkan")
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        }

    },

    created(){
        this.init()
    }
}
</script>
